import React, { useState } from 'react'
import Loader from '../../../components/Loader'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import Responsive from '../../../assets/config/Responsive'
import AddButton from '../../../components/v2/buttons/AddButton'
import { useTranslation } from 'react-i18next'
import CloseIcon from '../../../assets/icons/JSX/CloseIcon'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useNavigate } from 'react-router-dom'
import {
  CriticalIllnessState,
  addEmptyInsured,
  removeInsuredAtIndex,
  updateInsuredAtIndex,
  updateInsuredGenderAtIndex,
} from '../../../store/criticalIllnessSlice'
import { useAppDispatch, useAppSelector } from '../../../store'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import BirthDayInput from '../../../components/v2/BirthDayInput'
import dayjs from 'dayjs'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import GenderCard from '../../../components/v2/GenderCard'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import api from '../../../api'
import { AppState } from '../../../store/appSlice'

const CriticalAddInsured = () => {
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { t } = useTranslation()
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-age-of-insured')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  const leftCompanies = {
    companiesCount: 2,
  }
  //
  const [openAccordion, setOpenAccordion] = useState<number | null>(0)
  //
  const _toggleAccordion = (index: number) => {
    if (openAccordion === index) {
      setOpenAccordion(null)
    } else {
      setOpenAccordion(index)
    }
  }
  //
  const isDataValid = (data: any) => {
    if (!Array.isArray(data)) {
      return false
    }
    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      if (
        item.age === null ||
        item.age === 0 ||
        item.date === null ||
        item.date.length !== 14 ||
        Number(item.age) < 0
      ) {
        return false
      }
    }

    return true
  }
  //
  const maxAgeValidation = (insuredDate: number[]) => {
    for (const insured of insuredDate) {
      if (insured >= 123) {
        return false
      }
    }
    return true
  }
  //
  const mainLoading = isPageInfoLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        <Block>
          {filter.insuredInfo?.map((item, index) => (
            <WhiteBox key={index}>
              <BlockHead>
                <CloseButton onClick={() => _toggleAccordion(index)}>
                  <RightArrow
                    style={{
                      transform: openAccordion === index ? `rotate(0deg)` : `rotate(-180deg)`,
                    }}
                  />
                </CloseButton>

                <MediumTitle onClick={() => _toggleAccordion(index)}>{`${t('insured')} ${index + 1}`}</MediumTitle>

                <RemoveBtn onClick={() => dispatch(removeInsuredAtIndex(index))}>
                  <CloseIcon />
                </RemoveBtn>
              </BlockHead>

              {openAccordion === index ? (
                <PersonalInfoBox>
                  <BirthDayInputStyle
                    id="insured-birtday-input"
                    label={t('dateOfBirth')}
                    placeholder={t('dayMonthYear')}
                    value={item.date || ''}
                    width="fullWidth"
                    onChange={(value: string) => {
                      const [day, month, year] = value.split(' / ')

                      // create a new Date object from the provided date
                      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))

                      // Get the current Date
                      const currentDate = new Date()

                      // calculate the difference in years
                      let yearDifference = currentDate.getFullYear() - date.getFullYear()

                      // calculate the difference in months
                      const monthDifference = currentDate.getMonth() - date.getMonth()

                      // calculate the difference in days
                      const dayDifference = currentDate.getDate() - date.getDate()

                      // if the birthday for this year hasn't accured yet, subtract 1 from the age
                      if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
                        yearDifference--
                      }

                      //convert the input date to the desired format
                      const dateParts = value?.split('/').map((part) => part.trim())
                      const formattedDate = dateParts && new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`)

                      // dispatch the updated insurer date

                      if (true) {
                        dispatch(
                          updateInsuredAtIndex({
                            insuredIndex: index,
                            age: yearDifference === 0 ? 1 : yearDifference,
                            date: value,
                            dateFormat: dayjs(formattedDate).format('YYYY-MM-DD'),
                          }),
                        )
                      }
                    }}
                  />

                  <ChooseGenderLabel>{t('gender')}</ChooseGenderLabel>
                  <GenderBlock>
                    <GenderCard
                      selected={
                        filter.insuredInfo && filter.insuredInfo.find((x, i) => i === index && x.gender === 'female')
                          ? true
                          : false
                      }
                      gender="female"
                      femaleText={`${t('female')}`}
                      onClick={() => dispatch(updateInsuredGenderAtIndex({ insuredIndex: index, gender: 'female' }))}
                    />
                    <GenderCard
                      selected={
                        filter.insuredInfo && filter.insuredInfo.find((x, i) => i === index && x.gender === 'male')
                          ? true
                          : false
                      }
                      gender="male"
                      maleText={`${t('male')}`}
                      onClick={() => dispatch(updateInsuredGenderAtIndex({ insuredIndex: index, gender: 'male' }))}
                    />
                  </GenderBlock>
                </PersonalInfoBox>
              ) : null}
            </WhiteBox>
          ))}
          {filter.insuredInfo?.length !== 0 && (
            <RemainingCompanies
              style={{
                opacity: leftCompanies ? '1' : '0',
                marginInline: 'auto',
              }}
              text={`${t('offerAvailable')}: ${leftCompanies?.companiesCount} `}
            />
          )}
        </Block>

        <AddButtonStyle>
          <AddButton
            text={t('addInsured')}
            onClick={() => [_toggleAccordion((openAccordion as number) + 1), dispatch(addEmptyInsured())]}
          />
        </AddButtonStyle>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [navigate('/critical-choose-currency')]}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              (isDataValid(filter.insuredInfo) === true ? true : false) &&
              filter.insuredInfo &&
              filter.insuredInfo.find((x) => x.age !== 0) &&
              maxAgeValidation(filter.insuredInfo.map((x) => x.age)) &&
              filter.insuredInfo.find((x) => x.date !== null) &&
              (filter.insuredInfo.find((x) => x.gender === null) ? false : true) &&
              filter.insuredInfo.find((x) => x.gender !== '')
                ? false
                : true
            }
            onClick={() => [navigate('/critical-choose-method')]}
          />
        </Buttons>
      </Content>
      <BackgroundIcon />
    </Wrapper>
  )
}
//

const Block = styled.div`
  max-width: 464px;
  width: 100%;
`

const BlockHead = styled.div`
  display: flex;
  align-items: center;
`
const CloseButton = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  transform: rotate(-90deg);
  position: absolute;
  left: 14px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 17px;
    height: 14px;
    color: ${Colors.primaryBlack};
  }

  ${Responsive.mobile} {
    left: 12px;
  }
`
const RemoveBtn = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  position: absolute;
  top: 16px;
  right: 16px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 16px;
    height: 13px;
    color: ${Colors.nevadaGrey};
  }

  ${Responsive.mobile} {
    svg {
      width: 14px;
      height: 11px;
    }
  }
`

const PersonalInfoBox = styled.div``

const MediumTitle = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  font-weight: 500;
  cursor: pointer;
  ${Responsive.mobile} {
    padding-left: 20px;
  }
`
const GenderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
`
const BirthDayInputStyle = styled(BirthDayInput)`
  margin-block: 20px;
  label {
    font-weight: normal;
    margin-bottom: 10px;
  }
`

const ChooseGenderLabel = styled.label`
  font-size: 14px;
  margin-bottom: 10px;
  color: ${Colors.primaryGrey};
`

const AddButtonStyle = styled.div`
  margin-top: 30px;
  display: grid;
  place-items: center;
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

const WhiteBox = styled.div`
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 ${Colors.shadow};
  border-radius: 8px;
  padding: 34px 48px;
  max-width: 464px;
  width: 100%;
  position: relative;
  margin-top: 32px;

  ${Responsive.mobile} {
    padding: 25px 20px;
    width: 100%;
  }
`
const Wrapper = styled.div`
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`

export default CriticalAddInsured
